import {createEntityAdapter} from '@reduxjs/toolkit';
import {EventListItem} from 'api/events/events.types';
import dayjs from 'utils/dayjs';

/**
 * CRUD adapter for handling UpcomingEvents data within the store.
 * Default is Keyed by eventId, but sorted by the start date then alphabetically by destinationTitle.
 *
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const upcomingEventsAdapter = createEntityAdapter<EventListItem>({
    selectId: (event) => event.eventId,
    sortComparer: (a, b) => {
        // Primary sort by eventStarts
        const timeA = dayjs(a.eventStarts).valueOf();
        const timeB = dayjs(b.eventStarts).valueOf();

        // If times are different, sort by time
        if (timeA !== timeB) {
            return timeA - timeB;
        }

        // Secondary sort: if times are the same, sort alphabetically by destinationTitle
        return (a.destinationTitle || '').localeCompare(
            b.destinationTitle || ''
        );
    },
});
